import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarCategoriaPayload, paramsListCategoria, atualizarCategoriaPayload } from '../../interfaces/categorias'

export function novaCategoria (payload: cadastrarCategoriaPayload) {
    return BASEURLGESTTOR.post('/categorias', payload)
}

export function lisatarCategorias (params: paramsListCategoria) {
    return BASEURLGESTTOR.get (`/categorias?descricao=${params.descricao}&situacao=${params.situacao}`)
}

export function atualizarCategoria (id: string, payload: atualizarCategoriaPayload) {
    return BASEURLGESTTOR.patch(`/categorias/${id}`, payload)
}
